import { render, staticRenderFns } from "./AmeliaRevAudio.vue?vue&type=template&id=2ab84b14"
import script from "./AmeliaRevAudio.vue?vue&type=script&lang=js"
export * from "./AmeliaRevAudio.vue?vue&type=script&lang=js"
import style0 from "./AmeliaRevAudio.vue?vue&type=style&index=0&id=2ab84b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports